import reducers from "./reducers";

export default {
    name: "inform",
    reducers,
};
